export const colors = {
  lightBlue: '#44BDD0',
  darkBlue: '#033D7F',
  white: '#fff',
  lightGrey: '#C4C4C4',
  grey: '#D3DAE0',
  black: '#242424',
  blue: '#007AD1',
  darkInfo: '#006FC3',
  lighterBlue: '#E3F4FF',
  congressBlue: '#034D83',
  grey70: '#b3b3b3',
  gullGrey: '#9EACBC',
  aliceBlue: '#F7FCFF',
  blackPearl: '#13171C',
  darkGrey: '#4E5D70',
  brightGrey: '#535762',
  athensGray: '#E9ECF0',
  lightWarning: '#FFF6E8',
  backgroundGray: '#F9FAFB',
  backgroundRed: '#FFF1F1',
  darkError: '#C3362E',
  darkerError: '#9A2B24',
  darkGreen: '#0E7016',
  darkWarning: '#AF5304',
}

export const device = {
  mobile: '375px',
  mobileLarge: '425px',
  tablet: '768px',
  tabletLarge: '992px',
  desktopSmall: '1024px',
  desktop: '1440px',
}
